const messages = {
  dashboard: {
    title: "Nadzorna ploča servisa",
    description:
      "Srdačno dobrodošli na vašu nadzornu ploču. Ovdje možete pregledati trenutne pokazatelje i sudionike iz vaše klijentske baze.",
    overview: {
      title: "Pregled sudionika kupaca",
      description:
        'Tvrtke koje su se registrirale na BRIDGESTONE <span class="text-danger">PLUS</span> i koje možemo povezati s vama preko broja kupca.',
      month: "Novo ovog mjeseca",
      year: "Novo ove godine",
      all: "Ukupno",
    },
    credits: {
      title: "Uknjižavanje bodova",
      description:
        "Nagradni bodovi dodijeljeni sudionicima na temelju dostavljenih podataka o prodaji.",
      month: "Prošli mjesec",
      year: "Tekuća godina",
      prev_year: "Ukupno",
      allDealers: "Svi bodovi trgovaca",
      allPoints: "Svi bodovi",
      prev_month: "Prošli mjesec",
    },
    details: {
      title: "Sudionici kupci detaljno",
      description:
        'U nastavku su navedene tvrtke koje su se registrirale na BRIDGESTONE <span class="text-danger">PLUS</span> s Bridgestone brojem kupca i koje su vam dodijeljene kao odgovornom. Jednostavno koristite funkcije sortiranja za drugačiji redoslijed ili funkciju pretrage.<br/><br/> <b>Napomena:</b> Ako kliknete na stanje bodova, doći ćete do detaljnog izvještaja računa.',
    },
    lastImport:
      'Zadnji uvoz podataka o prodaji: <br/> <span class="text-danger">{date}</span>',
    kickback: {
      description:
        "Sudionicima se kešbek naknade uknjižavaju na temelju dostavljenih podataka o prihodima.",
    },
    tyres: {
      title: "Gume",
      description: "Gume kupljene od strane sudionika programa",
    },
    short:
      "Dobrodošli na vašu nadzornu ploču. Ovdje možete pregledati trenutne podatke i tvrtke sudionice iz vaše klijentske baze.",
    headers: {
      city: "Grad",
      company: "Tvrtka",
      current_points: "trenutni bodovi",
      customer_number: "broj kupca",
      details: "detalji",
      last_login: "Zadnja prijava",
      name: "ime",
      postal_code: "Poštanski broj",
      street: "ulica",
      email: "Email",
    },
    reload: "Ponovno učitaj",
    exports: {
      title: "Izvezene Excel datoteke",
      downloadExcel: "Preuzmi Excel",
      running: "U tijeku",
      head: {
        name: "Naziv",
        status: "Status",
      },
    },
  },
};
export default {
  messages,
};
